'use client';

import { cn } from '../../../../lib/utils';
import { TEAM_LEAGUES_PLACEHOLDER_IMAGE } from '../../../global/utils/constants';
import { TeamLeagueOutstandingInvoice } from '../../../team-leagues/types';
import {
	Dialog,
	DialogActionButton,
	DialogBody,
	DialogCloseButton,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogSubTitle,
	DialogTitle
} from '../../../ui/dialog-v2';

interface PendingInvitationModalProps {
	invoice: TeamLeagueOutstandingInvoice;
	open: boolean;
	onClose: () => void;
	onContinue: () => void;
	className?: {
		closeButton?: string;
		actionButton?: string;
	};
}

export const PendingInvitationModal = ({ invoice, open, onClose, onContinue, className }: PendingInvitationModalProps) => {
	const handleClose = () => {
		onClose();
	};

	const handleContinue = () => {
		onContinue();
	};

	return (
		<Dialog
			open={open}
			onOpenChange={(open) => {
				if (!open) {
					handleClose();
				}
			}}
		>
			<DialogContent className="max-w-[560px]" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
				<DialogHeader>
					<DialogTitle>Team invitation</DialogTitle>
					<DialogSubTitle>
						You&apos;ve invited to join <span className="font-medium text-gray-900">{invoice.teamLeagueTeamTitle}</span> by{' '}
						<span className="font-medium text-gray-900">{invoice.captainName}</span>
					</DialogSubTitle>
				</DialogHeader>

				<DialogBody>
					{/* Team Card */}
					<div className="flex w-full items-center rounded-xl border border-gray-200 bg-white px-0 py-4 gap-4">
						<div className="flex shrink-0 flex-col items-center justify-center">
							{invoice.teamLogo?.url ? (
								<div className="relative h-20 w-40">
									<img src={invoice.teamLogo.url} alt={invoice.teamLeagueTeamTitle} className="object-contain" sizes="160px" />
								</div>
							) : (
								<div className="relative h-20 w-40">
									<img
										src={TEAM_LEAGUES_PLACEHOLDER_IMAGE}
										alt={invoice.teamLeagueTeamTitle}
										className="object-contain"
										sizes="160px"
									/>
								</div>
							)}
						</div>
						<div className="flex min-w-0 flex-1 flex-col justify-center pr-2">
							<p className="min-w-0 w-full truncate text-xs font-semibold text-gray-900 leading-[18px]">{invoice.teamLeagueTitle}</p>
							<p className="min-w-0 w-full break-words text-xl font-medium text-gray-900 leading-[30px] line-clamp-2">
								{invoice.teamLeagueTeamTitle}
							</p>
						</div>
					</div>
				</DialogBody>

				<DialogFooter>
					<DialogCloseButton className={cn('h-11 rounded-lg font-medium', className?.closeButton)} onClick={handleClose}>
						Close
					</DialogCloseButton>
					<DialogActionButton
						className={cn('bg-orange-500 text-white hover:!bg-orange-700 h-11 rounded-lg font-medium', className?.actionButton)}
						onClick={handleContinue}
					>
						Continue
					</DialogActionButton>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
